import { render, staticRenderFns } from "./tableList.vue?vue&type=template&id=74a14a1f&scoped=true&"
import script from "./tableList.vue?vue&type=script&lang=js&"
export * from "./tableList.vue?vue&type=script&lang=js&"
import style0 from "./tableList.vue?vue&type=style&index=0&id=74a14a1f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a14a1f",
  null
  
)

export default component.exports